import { useProjectTypeContext } from "./ProjectTypeProvider";

export default function AccessRoute({ projectTypes, children }) {
    const { projectTypeValue } = useProjectTypeContext();
    if (!projectTypes.includes(projectTypeValue)) {
        throw new Response("Not Found", { status: 404 });
    }
    return <>{children}</>;
}
